/* eslint-disable @typescript-eslint/no-explicit-any */
import type Highcharts from "highcharts";

function resetAxis(axis: Highcharts.Axis, redraw = true) {
  axis.setExtremes(undefined, undefined, redraw, false, {
    trigger: "zoom",
  });
}

export default function zoomReset(H: typeof Highcharts) {
  H.wrap(
    H.Chart.prototype,
    "init",
    function (
      this: Highcharts.Chart,
      proceed: { apply: (arg0: Highcharts.Chart, arg1: [Highcharts.Options]) => void },
      ...args: [Highcharts.Options]
    ) {
      proceed.apply(this, args);
      H.addEvent(this.container, "dblclick", (e: MouseEvent) => {
        const target = e.target;

        if (!(target instanceof Element)) return;

        // // Reset zoom by axis from corresponding axis
        // for (const axis of this.axes) {
        //   if (
        //     (axis as any).axisLine?.element === target ||
        //     (axis as any).axisLine?.element?.contains(target) ||
        //     (axis as any).axisTitle?.element === target ||
        //     (axis as any).axisTitle?.element?.contains(target) ||
        //     (axis as any).labelGroup?.element === target ||
        //     (axis as any).labelGroup?.element?.contains(target) ||
        //     /**
        //      * Using with `pointer-events: bounding-box on svg g tag`
        //      * we can target group tag to handle clicks.
        //      */
        //     (axis as any).axisGroup?.element === target ||
        //     (axis as any).axisGroup?.element?.contains(target)
        //   ) {
        //     e.preventDefault();
        //     e.stopPropagation();
        //     if (axis.options.zoomEnabled) resetAxis(axis, true);
        //   }
        // }

        // if (this.renderer.boxWrapper.element === target) {
        //   for (const axis of this.axes) {
        //     e.preventDefault();
        //     e.stopPropagation();
        //     if (axis.options.zoomEnabled) resetAxis(axis, false);
        //   }
        //   return this.redraw();
        // }

        for (const yAxis of this.yAxis) {
          if (yAxis.options.zoomEnabled) {
            const verticalScrollbar: Element | undefined = (yAxis as any)?.scrollbar?.group
              ?.element;
            const axisTitleElement: Element | undefined =
              (yAxis as any).axisTitle?.div || (yAxis as any).axisTitle?.element;
            const labelElement: Element | undefined =
              (yAxis as any).labelGroup?.div || (yAxis as any).labelGroup?.element;

            if (
              verticalScrollbar?.contains(target) ||
              labelElement?.contains(target) ||
              axisTitleElement?.contains(target)
            ) {
              e.preventDefault();
              e.stopPropagation();
              resetAxis(yAxis, false);
              this.redraw(false);
              continue;
            }
          }
        }

        if (!(this as any).navigator) {
          e.preventDefault();
          e.stopPropagation();
          for (const axis of this.xAxis) resetAxis(axis, false);
          for (const yAxis of this.yAxis) {
            if (yAxis.options.zoomEnabled) resetAxis(yAxis, false);
          }
          //   for (const yAxis of this.yAxis) {
          //     if (!yAxis.options.zoomEnabled) resetAxis(yAxis, false);
          //   }
          this.redraw(false);
          return;
        }

        // // horizontal
        const horizontalScrollbar: Element | undefined = (this as any)?.navigator?.scrollbar?.group
          ?.element;
        if (horizontalScrollbar?.contains(target)) {
          e.preventDefault();
          e.stopPropagation();
          for (const axis of this.xAxis) resetAxis(axis, false);
          this.redraw(false);
          return;
        }

        // // full
        const navigatorElement: Element | undefined =
          this.container.getElementsByClassName("highcharts-navigator")[0];
        if (navigatorElement?.contains(target)) {
          e.preventDefault();
          e.stopPropagation();
          for (const axis of this.xAxis) resetAxis(axis, false);
          for (const yAxis of this.yAxis) {
            if (yAxis.options.zoomEnabled) resetAxis(yAxis, false);
          }
          this.redraw(false);
          return;
        }
      });
    },
  );
}
